import { configureStore } from '@reduxjs/toolkit'
import initializers from 'src/modules/initializers'
import settingsSlice from 'src/modules/settings/settings_slice'
import layoutSlice from 'src/modules/layout/layout_slice'
import authSlice from 'src/modules/auth/auth_slice'
import homeSlice from 'src/modules/home/home_slice'

let store

export default function getStore() {
  return store
}

export function createMyStore() {
  store = configureStore({
    reducer: {
      auth: authSlice.reducer,
      layout: layoutSlice.reducer,
      settings: settingsSlice.reducer,
      home: homeSlice.reducer,
    },
    devTools: process.env.NODE_ENV !== 'production',
  })

  for (const initializer of initializers) {
    initializer(store)
  }
  return store
}

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
